import { getUrlWithAddedQueryParameters } from './index';
import { nodeParseQueryString } from 'owa-querystring';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

const FALLBACK_TODO_APP_LINK = 'https://to-do.microsoft.com';

export default function getTodoModuleUrl(utmSource?: string, removeFromOwa?: boolean): string {
    const userConfig = getUserConfiguration();
    const userOptions = userConfig.UserOptions;
    const upn = userConfig.SessionSettings?.UserPrincipalName;

    let url = FALLBACK_TODO_APP_LINK;
    let queryParams = {};

    if (userOptions?.ReactOptinSettings?.TasksRedirectUrl) {
        let queryString = '';
        [url, queryString] = userOptions.ReactOptinSettings.TasksRedirectUrl.split('?');
        queryParams = nodeParseQueryString(queryString);

        if (upn) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS7053 (24,13): Element implicitly has an 'any' type because expression of type '"auth_upn"' can't be used to index type '{}'.
            // @ts-expect-error
            queryParams['auth_upn'] = upn;
        }
    }
    if (utmSource) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7053 (31,9): Element implicitly has an 'any' type because expression of type '"utm_source"' can't be used to index type '{}'.
        // @ts-expect-error
        queryParams['utm_source'] = utmSource;
    }
    if (removeFromOwa) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7053 (37,16): Element implicitly has an 'any' type because expression of type '"fromOwa"' can't be used to index type '{}'.
        // @ts-expect-error
        delete queryParams['fromOwa'];
    }

    if (Object.keys(queryParams).length > 0) {
        return getUrlWithAddedQueryParameters(url, queryParams);
    }

    return url;
}
